<button mat-icon-button class="close-button">
  <!-- <img
    class="on-close"
    src="assets/images/nomination close btn.svg"
    (click)="onClose()"
    alt="close-icon"
  /> -->
  <mat-icon class="on-close" (click)="onClose()">close</mat-icon>
 
</button>

<div class="container p-3 m-3">
  <p class="title mb-4"><b>Manage Brands</b></p>

  <table class="table custom-table">
    <thead class="custom-header">
      <tr>
        <th scope="col" class="header-1">S.No.</th>
        <th scope="col" class="header-2">Brand</th>
        <th scope="col" class="header-3">Status</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let brand of pagedBrands; let i = index">
        <td>{{ pageIndex * pageSize + i + 1 }}.</td>
        <td>
          <img class="brand-icon" [src]="brand?.brandImage" alt="brand" width="50" height="50" />
          <span>{{ brand.brandName }}</span>
        </td>
        <td>
          <mat-slide-toggle
            (change)="toggleBrandVisibility(brand)"
            class="mt-1"
            [disableRipple]="true"
            [(ngModel)]="brand.active"
          ></mat-slide-toggle>
        </td>
      </tr>

      <!-- Pagination Row -->
      <tr class="pagination-row">
        <td colspan="3">
          <div class="custom-paginator-container">
            <div class="paginator-range-label">
              {{ pageIndex * pageSize + 1 }} –
              {{
                (pageIndex + 1) * pageSize > allBrands.length
                  ? allBrands.length
                  : (pageIndex + 1) * pageSize
              }}
              of {{ allBrands.length }}
            </div>
            <mat-paginator
              [length]="allBrands.length"
              [pageSize]="pageSize"
              [pageIndex]="pageIndex"
              [pageSizeOptions]="[5]"
              (page)="onPageChange($event)"
              [hidePageSize]="true"
              [showFirstLastButtons]="true"
            ></mat-paginator>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
